<template>
  <div
    id="app"
    @click="onDocumentClick"
  >
    <div class="container-fluid">
      <router-view />
    </div>
  </div>
</template>

<script>
import './scss/site.scss'
import { iframeParentCommunication } from './mixins/iframeParentCommunication'
import axios from 'axios'

export default {
  name: 'App',
  mixins: [iframeParentCommunication],
  created () {
    axios.get('../settings/load')
      .then(({ data }) => {
        try {
          const { emailEditorURI } = data.customizationConfig.einsightConfig
          const script = document.createElement('script')
          script.src = emailEditorURI + 'javascript/plugin'
          document.getElementsByTagName('head')[0].appendChild(script)
        } catch (e) {
          console.log(e)
        }
        this.$store.commit('SET_APP_CONFIG', data)
        this.$store.commit('SET_CUSTOM_LINKS_HOST', data.addonsApiSettings.uri ?? null)
      })
      .catch(error => {
        console.log(error)
      })
  },
  mounted () {
    const externalId = this.$route.query.externalId
    const clientId = this.$route.query.clientId
    const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
    const eGalleryUid = this.$route.query.eGalleryUid
    const canCreateTemplate = this.$route.query.canCreateTemplate

    if (this.$route.query.isSearchingTemplate === 'true') {
      this.$store.commit('SET_SEARCHING_TEMPLATE', true)
    }
    if (this.$route.query.isCreatingCampaign === 'true') {
      this.$store.commit('SET_CREATING_CAMPAIGN_TEMPLATE', true)
    }

    if (eGalleryUid) {
      this.$store.commit('SET_EGALLERY_UID', parseInt(eGalleryUid))
    }
    if (userEmail) {
      this.$store.commit('SET_USER_EMAIL', userEmail)
      this.$store.dispatch('setLocale', { userEmail })
    }
    if (canCreateTemplate) {
      this.$store.commit('SET_CAN_CREATE_TEMPLATE', canCreateTemplate === 'true')
    }
    if (this.$store.getters.getExternalId === 0) {
      if (externalId) {
        this.$store.commit('SET_EXTERNALID', externalId)
        this.$store.commit('SET_CLIENTID', clientId)
      }
      return
    }
    this.config = {
      height: () => document.body.clientHeight,
      width: () => '100%',
      tbi_update_property_info: this.updatePropertyInfo,
      tbi_set_parent_domain: this.setAppDomain,
      tbi_route: this.routeRequest,
      tbi_refresh_campaigns: this.refreshCampaigns,
      tbi_update_access_settings: this.updateAccessSettings
    }
    this.InitCommunication(this.config)
    const that = this
    this.onElementHeightChange(document.body, document.documentElement, function () {
      const data = { action: 'eIn_iframe_height_change', value: document.body.clientHeight }
      that.SendMessageToParent(data)
    })

    // Getting the parent eInsight application domain
    this.SendMessageToParent(
      { action: 'eIn_get_domain' }
    )

    if (this.$route && externalId) {
      this.init()
      this.$store.commit('SET_EXTERNALID', externalId)
      this.$store.commit('SET_CLIENTID', clientId)
      this.$store.dispatch('setAccountId', { externalId, userEmail })
      this.$store.dispatch('setEditorsTypes', { userEmail })
      this.$store.dispatch('setTags', { userEmail })
      this.$store.dispatch('setEditorPermissions', { externalId, userEmail })
      this.$store.dispatch('setUsers', { userEmail })
    } else {
      const waitingInitialization = setInterval(() => {
        console.log('waiting TBI initialization')
        if (window.InitializationWatcher.configLoaded) {
          this.init()
          clearInterval(waitingInitialization)
        }
      }, 500)
    }

    if (window.self !== window.top) {
      if (!document.body.className.includes('in-iframe')) {
        document.body.className += 'in-iframe'
      }
    }
  },
  methods: {
    onElementHeightChange (elm, html, callback) {
      let lastHeight = elm.clientHeight
      let newHeight = -1;
      (function run () {
        newHeight = Math.max(elm.clientHeight, elm.scrollHeight, elm.offsetHeight, html.offsetHeight)
        if (lastHeight !== newHeight) {
          callback()
        }

        lastHeight = newHeight

        if (elm.onElementHeightChangeTimer) {
          clearTimeout(elm.onElementHeightChangeTimer)
        }

        elm.onElementHeightChangeTimer = setTimeout(run, 100)
      })()
    },
    setAppDomain (data) {
      console.log('setAppDomain data: ', data)
      this.$store.commit('SET_EINSIGHT_URI', data.eInsightUri)
      window.InitializationWatcher.configLoaded = true
    },
    // this is the method to handle the event from einsight
    // for changing the accountId and companyid when einsight
    // nav drop down changes
    updatePropertyInfo (propertyinfo) {
      if (!propertyinfo) {
        return
      }
      const userEmail = atob(this.$route.query.userEmail)
      this.$store.commit('SET_EXTERNALID', propertyinfo.companyid)
      this.$store.commit('SET_CLIENTID', propertyinfo.clientid)
      this.$store.commit('SET_ENV_NAME', propertyinfo.environmentName)
      this.$store.dispatch('setAccountId', { externalId: propertyinfo.companyid, userEmail })
    },
    updateAccessSettings (accessSettings) {
      if (!accessSettings) {
        return
      }
      this.$store.commit('SET_CAN_CREATE_TEMPLATE', accessSettings.canCreateTemplate === 'true')
    },
    init () {
      this.SendMessageToParent(
        { action: 'eIn_iframe_init_done' }
      )
    },
    routeRequest (data) {
      console.log('routeRequest: ', data)
      this.$router.push(data.hash)
    },
    onDocumentClick () {
      const accountId = this.$store.getters.getAccountId
      if (accountId) {
        this.SendMessageToParent(
          { action: 'eIn_Close_Menu_DropDown' }
        )
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css";
  @import "../node_modules/@syncfusion/ej2-vue-popups/styles/bootstrap4.css";
  @import "../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import '../node_modules/@syncfusion/ej2-vue-notifications/styles/material.css';
  #app {
    padding: 0 9px 0;
    overflow: hidden;
    width: 100%;
    min-height: 95vh;
  }

   .e-toast-container {
    .e-toast {
      .e-toast-message {
        .e-toast-title {
          color: $success !important;
        }
        .e-toast-content {
          color: $success !important;
          padding: 0 !important;
        }
      }
      &.notification-error {
        .e-toast-message {
          .e-toast-title {
            color: $danger !important;
          }
          .e-toast-content {
            color: $danger !important;
          }
        }
        border: 1px solid rgba(168,40,35,.5) !important;
        background-color: #faeae9 !important;
        box-shadow: 0 0.125rem 0.5rem -0.0625rem rgba(0,0,0, 0.1) !important;
      }
      &.notification-info {
        .e-toast-message {
          .e-toast-title {
            color: #2d76b7 !important;
          }
          .e-toast-content {
            color: black !important;
          }
        }
        .e-toast-close-icon {
         color: #2D76B7;
         margin-top: -8px;
      }
        border: 2px solid #2D76B7;
        background-color: #E9F2FA !important;
      }
      .e-toast-close-icon {
        color: #000;
        &:before {
          content: '\00d7' !important;
          font-size: 24px;
          font-weight: bold;
          margin-top: -2px;
          // font-family: Arial, sans-serif;
        }
      }
    }
  }
  #dialog-schedule {
    max-height: none !important;
  }
</style>
